<template>
    <div class="fin-flex fin-max-h-[750px] fin-h-full fin-min-h-[750px] fin-w-full fin-items-center fin-justify-center fin-bg-slate-50">
        <div class="fin-border fin-border-white fin-flex fin-w-full fin-bg-white lg:fin-max-w-[1200px] lg:fin-px-5 lg:fin-rounded-lg lg:fin-shadow-lg fin-overflow-hidden">
            <div class="fin-flex fin-flex-1 fin-flex-col fin-justify-center fin-py-12 fin-px-4 sm:fin-px-6 lg:fin-flex-none lg:fin-px-20 xl:fin-px-24">

                <div v-loading="loading" class="fin-mx-auto fin-w-full fin-max-w-sm lg:fin-w-96">
                    <div>
                        <span v-if="_.get(form, 'intro_text')" v-html="_.get(form, 'intro_text')"></span>
                        <span v-else>
                            <h2 class="fin-mt-6 fin-text-3xl fin-font-bold fin-tracking-tight fin-text-gray-900">Get A Faster Personalised Rate Now</h2>
                            <p>Complete each step the best you can to help us find the lowest rate and repayment for you</p>
                        </span>
                    </div>

                    <el-form class="fin-mt-6" :model="formEntry" :rules="rules" ref="fastTrackEntry">
                        <el-form-item size="small" label="First Name" prop="first_name">
                            <el-input v-model="formEntry.first_name" type="text"></el-input>
                        </el-form-item>
                        <el-form-item size="small" label="Last Name" prop="last_name">
                            <el-input v-model="formEntry.last_name" type="text"></el-input>
                        </el-form-item>
                        <el-form-item size="small" label="Phone" prop="phone">
                            <el-input v-model="formEntry.phone" type="tel"></el-input>
                        </el-form-item>
                        <el-form-item size="small" label="Email" prop="email">
                            <el-input v-model="formEntry.email" type="email"></el-input>
                        </el-form-item>
                        <el-button type="primary" size="small" class="fin-mt-3" @click="submitForm">Get Started</el-button>
                    </el-form>
                </div>
            </div>
            <div class="fin-relative fin-hidden fin-w-0 fin-flex-1 lg:fin-block">
                <img v-if="_.get(form, 'background_image')" class="fin-absolute fin-inset-0 fin-h-full fin-w-full fin-object-cover" :src="_.get(form, 'background_image_url')" alt="" />
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Embedded",

        components: {},

        props: {
            formStore: {
                required: false,
                type: String,
                default: "formStore",
            },
        },

        mixins: [],

        data() {
            return {
                loading: false,
                formEntry: {
                    amount: '0'
                },
                rules: {
                    first_name: [{required: true, message: "First Name is Required", trigger: "blur"}],
                    last_name: [{required: true, message: "Last Name is Required", trigger: "blur"}],
                    email: [
                        {required: true, message: "Email is Required", trigger: ['blur']},
                        {required: true, pattern:/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/, message: "Please input a valid email address", trigger: ['blur']}],
                    phone: [
                        {required: true, message: "Phone is Required", trigger: ['blur']},
                        {required: true, pattern:/^04\d{8}$/, message: 'Please input a valid mobile number', trigger: ['blur'] }],
                }
            };
        },
        mounted() { },
        methods: {
            submitForm(formName) {
                this.$refs["fastTrackEntry"].validate((valid) => {
					if (valid) {
                        this.loading = true
                        axios
                            .post(`/embedded/create-entry?api=${window.Embedded}`, { ...this.formEntry })
                            .then((res) => {
                                const { core, form, formType } = res.data;
                                this.$router.push({ name: "embeddedForm", params: { coreProp: core, formProp: form, formType } }).catch(() => { });
                            })
                            .finally(() => {
                                this.loading = false
                            })
                    }
                });
            },
        },

        computed: {
            form() {
                return this.$store.getters[`${this.formStore}/form/get`]
            }
        },
    }
</script>
<style lang="scss" scoped>
    .el-form-item--small .el-form-item__content, .el-form-item--small .el-form-item__label {
        line-height: 16px!important;
    }

    .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
        margin-bottom: 26px!important;
    }
</style>
